import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, Subject, timer } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { MfaService } from '../../services/mfa.service';
import { FlexModule } from '@angular/flex-layout/flex';
import { NgIf } from '@angular/common';

@Component({
    selector: 'mfa-simulate-login',
    templateUrl: './simulate-login.component.html',
    styleUrls: ['./simulate-login.component.scss'],
    imports: [FlexModule, NgIf]
})
export class SimulateLoginComponent implements OnInit, OnDestroy {
  constructor(private route: ActivatedRoute, private mfa: MfaService) {}
  onDestroy$ = new Subject<void>();
  loginSimulated = false;
  isAuthorized = false;
  referenceId: string | null = null;
  ngOnDestroy() {
    this.onDestroy$.next();
  }

  ngOnInit(): void {
    combineLatest([
      this.route.paramMap,
      timer(0, 5000).pipe(takeUntil(this.onDestroy$))
    ])
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(([params]) => {
        const id = params.get('id');
        if (id) {
          if (!this.loginSimulated) {
            this.loginSimulated = true;
            this.mfa
              .simulateLogin(id)
              .pipe(take(1))
              .subscribe((rId) => (this.referenceId = rId));
          } else if (this.referenceId && !this.isAuthorized) {
            this.mfa
              .isPushAuthorized(this.referenceId)
              .pipe(take(1))
              .subscribe((result) => (this.isAuthorized = result));
          }
        }
      });
  }
}
